<template>
    <div class="af-attribute-filter afu-my-4 afu-pt-5 afu-pb-2 afu-px-4 afu-shadow-secondary afu-rounded-secondary afu-border-neutral-light afu-bg-neutral-light">
        <C1Label class="afu-mb-3 afu-text-secondary">
            <span class="af-text--5xl afu-uppercase afu-font-bold afu-tracking-widest">{{ $t('label.location') }}</span>
        </C1Label>
        <div
            v-if="showTypeahead"
            class="afu-mb-3"
        >
            <C1Typeahead
                :options="options"
                :placeholder="$t('label.search_within_value', { 'value1': attributes.length, 'value2': $t('label.locations')})"
                clean-after-select
                no-icon
                @search="searchAttributes"
                label-key="value"
                value-key="id"
                @hit="onSelect"
            />
        </div>

        <ul class="afu-m-0 afu-p-0 afu-list-none">
            <li
                v-for="(selectedAttribute, index) in selectedAttributes"
                :key="`${selectedAttribute.id}_${index}`"
                class="afu-text-base afu-text-black afu-mb-3 afu-flex afu-items-center"
            >
                <div
                    class="afu-cursor-pointer afu-flex afu-items-center"
                >
                    <input
                        type="checkbox"
                        :id="selectedAttribute.id"
                        class="afu-mr-2"
                        :checked="selectedAttributes.some(attr => attr.id === selectedAttribute.id)"
                        @change="onSelect(selectedAttribute)"
                    />
                    <label :for="selectedAttribute.id" class="afu-text-sm">
                        {{ selectedAttribute.value }}
                    </label>
                </div>
            </li>
            <li
                v-for="(visibleAttribute, index) in visibleAttributes"
                :key="`${visibleAttribute.id}_${index}`"
                class="afu-text-base afu-text-black afu-mb-4 afu-flex afu-items-center"
                :class="{ 'afu-ml-5': selectedAttributes.length || visibleAttribute.indent }"
            >
                <div
                    class="afu-cursor-pointer afu-flex afu-items-center"
                >
                    <input
                        type="checkbox"
                        class="afu-mr-2"
                        @change="onSelect(visibleAttribute)"
                        :id="visibleAttribute.id"
                    />
                    <label :for="visibleAttribute.id">
                        <div class="afu-text-base afu-text-black">
                        <span
                            class="cls-item-label-text"
                        >
                            {{ visibleAttribute.value }}
                        </span>
                            <span
                                class="cls-item-count"
                                v-if="showTaxonomyCount"
                            >
                            ({{ visibleAttribute.count | numeral }})
                        </span>
                        </div>
                    </label>
                </div>
            </li>
        </ul>

        <div
            v-if="showTypeahead"
            class="afu-text-sm afu-text-gray-800 afu-bg-gray-300 afu-rounded-md afu-text-center afu-p-2 afu-mt-2"
        >
            {{ $t('filter.info') }}
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import numeral from 'numeral';

    import C1Label from '@/components/C1Components/C1Label';
    import C1Typeahead from '@/components/C1Components/C1Typeahead';

    export default {
        name: 'LocationFilter',

        filters: {
            numeral(value) {
                if (!value) {
                    return;
                }
                return numeral(value).format('0,0');
            },
        },

        components: {
            C1Label,
            C1Typeahead,
        },

        data() {
            return {
                maxVisible: 30,
                options: [],
            };
        },

        computed: {
            ...mapState({
                attributes(state) {
                    return (
                        state.search.searchPayload?.search_results?.aggregation
                            ?.location || []
                    );
                },
                selectedAttributes(state) {
                    if (state.search.searchPayload?.search_filters?.location?.id) {
                        return this.attributes.filter(
                            o =>
                                o.id ===
                                String(state.search.searchPayload?.search_filters?.location
                                    .id),
                        );
                    }
                    return [];
                },
            }),

            showTypeahead() {
                return this.attributes.length > this.maxVisible;
            },

            visibleAttributes() {
                const selectedAttributeIds = this.selectedAttributes.map(o => o.id);
                let attr = this.attributes;

                const topLvl = attr.filter(ele => ele['indent'] == null);
                const subLvl = attr.filter(ele => ele['indent']);

                if (topLvl.length > 1) {
                    attr = topLvl;
                } else if (topLvl.length == 1) {
                    if (topLvl[0].type == 'COUNTRY' && subLvl.length > 0) {
                        if (
                            window.afConfig?.show_country_locations_filter && window.afConfig?.show_country_locations_filter !== 'Yes'
                        ) {
                            attr = subLvl.map(ele => {
                                ele['indent'] = false;
                                return ele;
                            });
                        }
                    }
                } else {
                    attr = subLvl.map(ele => {
                        ele['indent'] = false;
                        return ele;
                    });
                }

                return attr.filter(o => !selectedAttributeIds.includes(o.id));
            },

            showTaxonomyCount() {
                return (window.afConfig?.hide_taxonomy_count === 'Yes') ? false : true;
            },
        },

        methods: {
            ...mapMutations('search', {
                $_STORE_SEARCH_FILTER_LOCATION: 'STORE_SEARCH_FILTER_LOCATION',
            }),

            onSelect(attributeOption) {
                let customAttributeOption = {};
                customAttributeOption = {
                    id: attributeOption.id,
                };
                this.$_STORE_SEARCH_FILTER_LOCATION(customAttributeOption);
            },

            searchAttributes(keyword) {
                const selectedAttributeIds = this.selectedAttributes.map(o => o.id);
                this.options = this.attributes.filter(
                    o =>
                        o.value.toLowerCase().startsWith(keyword) &&
                        !selectedAttributeIds.includes(o.id),
                );
            },
        },
    };
</script>
